<template>
    <div class="main-wrapper">
       <div class="wrapper">
       <form action="">
          <h1>Forgot Your Password?</h1>
          <div class="text-xs mb-6 font-bold">
            Enter a new password
          </div>
          <div class="input-box">
             <input type="password" placeholder="New Password" required>
             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
</svg>
          </div>
          <div class="input-box">
             <input type="password" placeholder="Confirm Password" required>
             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
  <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
</svg>
          </div>
          <button type="submit" class="btn">Save</button>
          <div class="register-link">
             <p> </p>
          </div>
       </form>
    </div>
    </div>
 </template>
 
 <script>
 
 </script>
 
 <style></style>